import React, { useCallback, useEffect, useMemo, useState } from 'react';
import { useDispatch, useSelector } from 'react-redux';
import { useNavigate } from 'react-router-dom';
import {Card, Col, Row, Space, Typography, Layout} from 'antd';
import Button from '@mui/material/Button';
import ButtonGroup from '@mui/material/ButtonGroup';
import Placeholder from '../../components/Placeholder';
import {fetchPortfoliosInBatches} from '../../api/portfolioApi';
import {setExchangeType} from '../../store/slices/exchange.slice';
import CompanyPortfolios from './components/CompanyPortfolios';
import {Edit3Icon, Edit2} from 'lucide-react';
import CompanyActionGrid from './components/CompanyActionGrid';
import useCompany from './useCompany';

const CompanyBrand = ({name, imgUrl}) => {
    const navigate = useNavigate();
    return (
        <Row justify={'start'} align={'middle'} wrap={false} className={'px-8 py-4 border-b border-gray-200'}>
            <Col>
                <Row justify={'start'} align={'middle'} className={'px-6'} wrap={false}>
                    <Col>
                        <div className={'flex justify-center items-center'}>
                            <img src={imgUrl} alt={'Company Logo'} className={'w-24 h-24 object-contain'}/>
                        </div>
                    </Col>
                    <Col flex={'1'}>
                        <div className={'px-3'}>
                            <Typography.Title level={3}>{name}</Typography.Title>
                        </div>
                    </Col>
                </Row>
            </Col>
            <Col>
                <ButtonGroup>
                    <Button variant={'text'} onClick={()=>navigate('/company/details/edit')}>
                        <Edit2 size={16} color={'rgba(0,0,0,0.5)'}/>
                    </Button>
                </ButtonGroup>
            </Col>
        </Row>
    );
}

const Company = () => {
    const navigate = useNavigate();
    const {
        companyDetails,
        companyName,
        logoUrl,
        mergedPortfolios,
        isLoading,
        allowAdminActions
    } = useCompany();
    if (isLoading) {
        return (
            <div className={'mx-auto'}>
                <Card bordered={false}>
                    <Placeholder title={'Company Details'} description={'No company details found'}/>
                </Card>
            </div>
        );
    }
    if (!allowAdminActions) {
        return (
            <Card className={'mx-auto py-8'} bordered={false}>
                <Placeholder title={'Company Details'}
                             imgUrl={'https://storage.googleapis.com/finiat-web-static-resources/platformIcons/in-progress.png'}
                             text={"Company Advisor Page Coming Soon!"}
                             textSize={'text-2xl'}
                />
            </Card>
        )
    }

    return (
        <Layout>
            <CompanyBrand name={companyName} imgUrl={logoUrl}/>
            <Row justify={'center'} align={'top'} gutter={[64, 64]} className={'p-8'}>
                <Col xs={12} xl={8}>
                    <CompanyActionGrid/>
                </Col>
                <Col xs={24} xl={16}>
                    <CompanyPortfolios portfolios={mergedPortfolios}/>
                </Col>
            </Row>
        </Layout>
    );
};
export default Company;